(() => {
  const initialiseTabs = () => {
    document.querySelectorAll('[data-sarasin-product-tabs]').forEach((tabs) => {
      const section = tabs.closest('.sarasin-v2__products');
      const cards = section?.querySelectorAll('[data-product-category]');
      const buttons = tabs.querySelectorAll('[data-product-filter]');

      if (!cards?.length || !buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.productFilter;

          buttons.forEach((tab) => {
            const selected = tab === button;
            tab.classList.toggle('is-active', selected);
            tab.setAttribute('aria-pressed', String(selected));
          });

          cards.forEach((card) => {
            card.hidden = filter !== 'all' && card.dataset.productCategory !== filter;
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseTabs, { once: true });
  } else {
    initialiseTabs();
  }
})();
